import * as _ from 'lodash';
import type { VoidFunctionComponent } from 'react';
import type { Simplify } from 'type-fest';

import { RouterLink } from '../../generic';

import BaseToast from './BaseToast';
import type { BaseToastProps } from './BaseToast';

type Props = Simplify<BaseToastProps & {
  link: string;
}>;

/*
 * A LinkToast displays normal Toast content along with a Link to an internal FOSSA route.
 * NOTE: This Toast should not be used directly. Please create Toasts through the addToast function.
 */
const LinkToast: VoidFunctionComponent<Props> = (props) => (
  // eslint-disable-next-line react/jsx-props-no-spreading
  <BaseToast {...(_.omit(props, 'link') as BaseToastProps)}>
    <RouterLink to={props.link}>
      Click here.
    </RouterLink>
  </BaseToast>
);

export default LinkToast;
